<template lang="pug">
.ball-pulse.loader
  div
  div
  div
</template>

<script>
export default {
  name: 'Loader',
  data() {
    return {
    };
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

.ball-pulse
  div
    background-color color-main
</style>



// WEBPACK FOOTER //
// src/components/partials/Loader.vue